enum DashboardActionType {
  LOAD_DASHBOARD = 'dashboard/LOAD_DASHBOARD',
  LOADING_DASHBOARD = 'dashboard/LOADING_DASHBOARD',
  LOADED_DASHBOARD = 'dashboard/LOADED_DASHBOARD',
  LOAD_DASHBOARD_FAILED = 'dashboard/LOAD_DASHBOARD_FAILED',
}

export default DashboardActionType;
